import { Layer } from 'effect';

import { BlobStore, layerMemory as blobStoreLayerMemory } from './blob-store.js';
import { DocumentGraphStore, layer as documentGraphStoreLayer } from './document-graph-store.js';
import { IndexStore, layer as indexStoreLayer } from './index-store.js';
import { SqlExecutor, layerMemory as sqlExecutorLayerMemory } from './sql-executor.js';

export type MemoryServices = BlobStore | SqlExecutor | DocumentGraphStore | IndexStore;

/**
 * Test aggregate — the same tags `CloudflareServices.layer` and
 * `NodeServices.layer` publish, composed from the co-located `layerMemory`
 * doubles. One SqlExecutor instance is shared with the domain stores.
 */
export const layer: Layer.Layer<MemoryServices> = Layer.mergeAll(
  blobStoreLayerMemory,
  documentGraphStoreLayer,
  indexStoreLayer,
).pipe(Layer.provideMerge(sqlExecutorLayerMemory));

export const layerMemory = layer;

export const MemoryServices = { layer } as const;
